import { render, staticRenderFns } from "./KanbanInsightCard.vue?vue&type=template&id=8061e7aa&scoped=true&"
import script from "./KanbanInsightCard.vue?vue&type=script&lang=js&"
export * from "./KanbanInsightCard.vue?vue&type=script&lang=js&"
import style0 from "./KanbanInsightCard.vue?vue&type=style&index=0&id=8061e7aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8061e7aa",
  null
  
)

export default component.exports